<!--==============================
=            BASECHAT            =
===============================-->
<template>
    <div>
        <beautiful-chat :participants="participants" :titleImageUrl="titleImageUrl" :onMessageWasSent="onMessageWasSent" :messageList="messageList" :newMessagesCount="newMessagesCount" :isOpen="isChatOpen" :close="closeChat" :icons="icons" :open="openChat" :showEmoji="true" :showFile="true" :showTypingIndicator="showTypingIndicator" :colors="colors" :alwaysScrollToBottom="alwaysScrollToBottom" :messageStyling="messageStyling" @onType="handleOnType" @edit="editMessage" />
    </div>
</template>
<script>
import CloseIcon from "vue-beautiful-chat/src/assets/close-icon.png";
import OpenIcon from "vue-beautiful-chat/src/assets/logo-no-bg.svg";
import FileIcon from "vue-beautiful-chat/src/assets/file.svg";
import CloseIconSvg from "vue-beautiful-chat/src/assets/close.svg";

export default {
    data() {
        return {
            icons: {
                open: {
                    img: OpenIcon,
                    name: "default"
                },
                close: {
                    img: CloseIcon,
                    name: "default"
                },
                file: {
                    img: FileIcon,
                    name: "default"
                },
                closeSvg: {
                    img: CloseIconSvg,
                    name: "default"
                }
            },
            participants: [{
                    id: "user1",
                    name: "Matteo",
                    imageUrl: "https://avatars3.githubusercontent.com/u/1915989?s=230&v=4"
                },
                {
                    id: "user2",
                    name: "Support",
                    imageUrl: "https://avatars3.githubusercontent.com/u/37018832?s=200&v=4"
                }
            ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
            titleImageUrl: "https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png",
            messageList: [{
                    type: "text",
                    author: `me`,
                    data: {
                        text: `Say yes!`
                    }
                },
                {
                    type: "text",
                    author: `user1`,
                    data: {
                        text: `No.`
                    }
                }
            ], // the list of the messages to show, can be paginated and adjusted dynamically
            newMessagesCount: 0,
            isChatOpen: false, // to determine whether the chat window should be open or closed
            showTypingIndicator: "", // when set to a value matching the participant.id it shows the typing indicator for the specific user
            colors: {
                header: {
                    bg: "#ef0078",
                    text: "#ffffff"
                },
                launcher: {
                    bg: "#ef0078"
                },
                messageList: {
                    bg: "#ffffff"
                },
                sentMessage: {
                    bg: "#ef0078",
                    text: "#ffffff"
                },
                receivedMessage: {
                    bg: "#f2bcf8",
                    text: "#222222"
                },
                userInput: {
                    bg: "#f2bcf8",
                    text: "#565867"
                }
            }, // specifies the color scheme for the component
            alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
            messageStyling: false // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
        };
    },
    methods: {
        sendMessage(text) {
            if (text.length > 0) {
                this.newMessagesCount = this.isChatOpen ?
                    this.newMessagesCount :
                    this.newMessagesCount + 1;
                this.onMessageWasSent({
                    author: "support",
                    type: "text",
                    data: {
                        text
                    }
                });
            }
        },
        onMessageWasSent(message) {
            // called when the user sends a message
            this.messageList = [...this.messageList, message];
        },
        openChat() {
            // called when the user clicks on the fab button to open the chat
            this.isChatOpen = true;
            this.newMessagesCount = 0;
        },
        closeChat() {
            // called when the user clicks on the botton to close the chat
            this.isChatOpen = false;
        },
        handleScrollToTop() {
            // called when the user scrolls message list to top
            // leverage pagination for loading another page of messages
        },
        handleOnType() {
            console.log("Emit typing event");
        },
        editMessage(message) {
            const m = this.messageList.find(m => m.id === message.id);
            m.isEdited = true;
            m.data.text = message.data.text;
        }
    }
};
</script>
<style scoped>
.sc-launcher {
    width: 60px;
    height: 60px;
    background-position: center;
    background-repeat: no-repeat;
    position: fixed;
    right: 25px;
    bottom: 25px;

    border-radius: 50%;
    margin-bottom: 70px !important;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-transition: -webkit-box-shadow 0.2s ease-in-out;
    transition: -webkit-box-shadow 0.2s ease-in-out;
    transition: box-shadow 0.2s ease-in-out;
    transition: box-shadow 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;
    cursor: pointer;
}

.sc-chat-window {
    width: 370px;
    height: calc(80% - 120px);
    max-height: 590px;
    position: fixed;
    right: 25px;
    bottom: 100px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0px 7px 40px 2px rgba(148, 149, 150, 0.1);
    box-shadow: 0px 7px 40px 2px rgba(148, 149, 150, 0.1);
    background: white;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 70px !important;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-transition: 0.3s ease-in-out;
    transition: 0.3s ease-in-out;
    border-radius: 10px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
</style>
<!--====  End of BASECHAT  ====-->